export const TerminalSettingPerDateType = {
	energy_inslag_cs: 1,
};
